import { render, staticRenderFns } from "./SalesOwnerExamine.vue?vue&type=template&id=6a1f8b18&scoped=true&"
import script from "./SalesOwnerExamine.vue?vue&type=script&lang=js&"
export * from "./SalesOwnerExamine.vue?vue&type=script&lang=js&"
import style0 from "./SalesOwnerExamine.vue?vue&type=style&index=0&id=6a1f8b18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1f8b18",
  null
  
)

export default component.exports